import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { IonList, IonInput, IonItem, IonLabel, IonButton, IonNote } from '@ionic/react';

import { updateLogs } from 'actions/ProjectDataActions';
import { getValue, numerifyInputValue, preventDefault } from 'helpers/events';
import useModel from 'hooks/useModel';
import { ProjectContext } from 'components/layouts/Project';
import MagnumInput from 'components/helpers/MagnumInput';


const DEFAULT_LOG = {
  installerName: '',
  inspectorName: '',
  inspectorCompany: '',
  installationEquipment: '',
  torqueMonitoringDevice: '',
  depthIncrement: 3,
}

export default function LogsForm({done})  {
  const dispatch = useDispatch();
  const project = useContext(ProjectContext);
  const {data: {loads, logs}} = project ?? {};
  const pushPierLoads = _.some(loads, (load) => load?.pileType == 'push_pier');
  const helicalLoads = _.some(loads, (load) => load?.pileType == 'helical');

  const [logFields, setLogsProperty] = useModel(_.pick(logs || DEFAULT_LOG, _.keys(DEFAULT_LOG)));

  const save = () => {
    dispatch(updateLogs(logFields));
    done();
  };

  return (
    <form onSubmit={preventDefault(save)}>
      <IonList lines="full" className="narrow-container">
        <IonItem>
          <MagnumInput label="Installer Name"
            value={logFields.installerName}
            onChange={getValue(setLogsProperty('installerName'))}/>
        </IonItem>
        <IonItem>
          <MagnumInput label="Inspector Name"
            value={logFields.inspectorName}
            onChange={getValue(setLogsProperty('inspectorName'))}/>
        </IonItem>
        <IonItem>
          <MagnumInput label="Inspector Company"
            value={logFields.inspectorCompany}
            onChange={getValue(setLogsProperty('inspectorCompany'))}/>
        </IonItem>
        <IonItem>
          <MagnumInput label={`Installation Equipment${pushPierLoads ? ' (Ram)' : ''}`}
            value={logFields.installationEquipment}
            onChange={getValue(setLogsProperty('installationEquipment'))}/>
            <IonNote slot="helper">
              If push piers, list Ram Designation. If helical piles, list make & model of machine
            </IonNote>
        </IonItem>
        {helicalLoads && (
          <IonItem>
            <MagnumInput label="Torque Monitoring Device"
              value={logFields.torqueMonitoringDevice}
              onChange={getValue(setLogsProperty('torqueMonitoringDevice'))}/>
          </IonItem>
        )}
        <IonItem>
          <IonLabel>Depth Increment</IonLabel>
          <IonInput type="number"
            value={logFields.depthIncrement}
            onIonChange={numerifyInputValue(setLogsProperty('depthIncrement'))}
            min={1}
            max={5}/>
            ft
        </IonItem>
        <div className="ion-padding">
          <IonButton expand="block" type="submit">Start Logging</IonButton>
        </div>
      </IonList>
    </form>
  )
}
